/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  getPublisherList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/publisher")
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_PUBLISHER_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getPublisherSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload)
      axios.get("/api/v2/exam/school_subject/textbook_subject?publisher_id=" + payload.publisher_id + "&subject_type_id=" + payload.subject_type_id + "&subject_detail_type_id=" + payload.subject_detail_type_id + "&school_type=" + payload.school_type + "&grade_id=" + payload.grade_id + "&detail=" + payload.detail)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_PUBLISH_SUBJECT_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getTextbookList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/publisher_textbook")
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_ALL_TEXTBOOK_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getTextbookListNew({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/publisher_textbook?school_type=3")
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_ALL_TEXTBOOK_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMiddleTextbookList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/middle_publisher_textbook")
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_ALL_TEXTBOOK_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMiddleTextbookListNew({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v4/exam/publisher_textbook?school_type=2")
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_ALL_TEXTBOOK_LIST", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getTextbookSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_subject' : '/api/v2/exam/middle_textbook_subject'
      axios.get(url + "?textbook_id=" + payload.textbookId + "&year=" + payload.year)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_TEXTBOOK_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createTextbookSubjectNew(context, payload) {
    return axios.post('/api/v4/exam/textbook_subject', payload).then(response => {
      if (response.data.result !== 'success') return Promise.reject(response.data)
      return response
    })
  },
  getTextbookSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_subject?textbook_id=' + payload.textbookId + '&year=' + payload.year)
        .then((response) => {
          if (response.data.result == 'success') {
            const gradeMap = { 7: '중1', 8: '중2', 9: '중3', 10: '고1', 11: '고2', 12: '고3' }
            const list = response.data.data_list.map((item) => {
              if (gradeMap[item.grade_id]) {
                return { ...item, name: item.name + ' - ' + gradeMap[item.grade_id] }
              }
              return item
            })
            commit('SET_TEXTBOOK_SUBJECT', list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getContentSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_content_subject' : '/api/v2/exam/middle_textbook_content_subject'
      axios.get(url + "?subject_id=" + payload.subjectId)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            console.log(response)
            commit("SET_BOOKS_MAIN_TABLE", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getContentSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_content_subject?subject_id=' + payload.subjectId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_BOOKS_MAIN_TABLE', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createMainTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(payload.schoolType == 3 ? '/api/v2/exam/textbook_content' : '/api/v2/exam/middle_textbook_content', {
        subject_id: payload.subjectId,
        name: payload.name,
        index: payload.index
    })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createMainTableNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v4/exam/textbook_content', {
        subject_id: payload.subjectId,
        name: payload.name,
        index: payload.index
      })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getBooksMiddleTable({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_content_main_subject' : '/api/v2/exam/middle_textbook_content_main_subject'
      axios.get(url + "?subject_id=" + payload.subjectId)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_BOOKS_MIDDLE_TABLE", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getBooksMiddleTableNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_content_main_subject?subject_id=' + payload.subjectId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_BOOKS_MIDDLE_TABLE', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createCenterTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(payload.schoolType == 3 ? '/api/v2/exam/textbook_content_main' : '/api/v2/exam/middle_textbook_content_main', {
        subject_id: payload.subjectId,
        content_id: payload.contentId,
        name: payload.name,
        index: payload.index
    })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createCenterTableNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v4/exam/textbook_content_main', {
        subject_id: payload.subjectId,
        content_id: payload.contentId,
        name: payload.name,
        index: payload.index
      })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getBooksSubTable({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_content_sub_subject' : '/api/v2/exam/middle_textbook_content_sub_subject'
      axios.get(url + "?subject_id=" + payload.subjectId)
        .then((response) => {
          console.log(response)
          if (response.data.result == 'success') {
            commit("SET_BOOKS_SUB_TABLE", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getBooksSubTableNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_content_sub_subject?subject_id=' + payload.subjectId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_BOOKS_SUB_TABLE', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createSubTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post(payload.schoolType == 3 ? "/api/v2/exam/textbook_content_sub" : "/api/v2/exam/middle_textbook_content_sub", {
        subject_id: payload.subjectId,
        content_id: payload.contentId,
        content_main_id: payload.contentMainId,
        name: payload.name,
        index: payload.index
    })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createSubTableNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v4/exam/textbook_content_sub', {
        subject_id: payload.subjectId,
        content_id: payload.contentId,
        content_main_id: payload.contentMainId,
        name: payload.name,
        index: payload.index
      })
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteMainTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/textbook_content/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteMainTableNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v4/exam/textbook_content?id=' + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteMiddleTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/textbook_content_main/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteMiddleTableNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v4/exam/textbook_content_main?id=' + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteSubTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/textbook_content_sub/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteSubTableNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v4/exam/textbook_content_sub?id=' + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getExamContent({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_exam_content' : '/api/v2/exam/middle_textbook_exam_content'
      url += payload.contentId == -1 ? '?textbook_subject_id=' + payload.subjectId : '?content_id=' + payload.contentId
      axios.get(url)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_TABLE_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getExamContentNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = '/api/v4/exam/textbook_exam_content'
      url += payload.contentId == -1 ? '?textbook_subject_id=' + payload.subjectId : '?content_id=' + payload.contentId
      axios.get(url)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getExamContentMain({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_exam_content' : '/api/v2/exam/middle_textbook_exam_content'
      axios.get(url + '?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit("SET_TABLE_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getExamContentMainNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_exam_content?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getExamContentSub({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_exam_content' : '/api/v2/exam/middle_textbook_exam_content'
      axios.get(url + '?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId + '&content_sub_id=' + payload.contentSubId)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit("SET_TABLE_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getExamContentSubNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_exam_content?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId + '&content_sub_id=' + payload.contentSubId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMutateSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_exam_content_trans' : '/api/v2/exam/middle_textbook_exam_content_trans'
      axios.get(url + '?content_id=' + payload.contentId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_MUTATE_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMutateSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_exam_content_trans?content_id=' + payload.contentId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_MUTATE_SUBJECT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMainMutateSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_exam_content_trans' : '/api/v2/exam/middle_textbook_exam_content_trans'
      axios.get(url + '?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit("SET_MUTATE_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMainMutateSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_exam_content_trans?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_MUTATE_SUBJECT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubMutateSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      var url = payload.schoolType == 3 ? '/api/v2/exam/textbook_exam_content_trans' : '/api/v2/exam/middle_textbook_exam_content_trans'
      axios.get(url + '?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId + '&content_sub_id=' + payload.contentSubId)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit("SET_MUTATE_SUBJECT", response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getSubMutateSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/api/v4/exam/textbook_exam_content_trans?content_id=' + payload.contentId + '&content_main_id=' + payload.contentMainId + '&content_sub_id=' + payload.contentSubId)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_MUTATE_SUBJECT', response.data.data_list)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createTableSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/textbook_exam" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT_ID' , response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createTableSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v4/exam/textbook_exam', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT_ID', response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createMiddleTableSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/exam/middle_textbook_exam" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT_ID' , response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  createMiddleTableSubjectNew({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/v4/exam/textbook_exam', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_TABLE_SUBJECT_ID', response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editTableSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/textbook_exam" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editTableSubjectNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v4/exam/textbook_exam" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteBookSubject(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/exam/textbook_exam/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  deleteBookSubjectNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete('/api/v4/exam/textbook_exam?id=' + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getBookExamInfo({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/all_subject_exam?id=" + payload.id + '&type=' + payload.type)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_ACTIVE_BOOK_SUBJECT' , response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  getMiddleBookExamInfo({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/exam/middle_textbook_exam?id=" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_ACTIVE_BOOK_SUBJECT' , response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editMainTitle(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/textbook_content" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editMainTitleNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v4/exam/textbook_content', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editMiddleTitle(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/textbook_content_main" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editMiddleTitleNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v4/exam/textbook_content_main', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editSubTitle(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/textbook_content_sub" , payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
  editSubTitleNew(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put('/api/v4/exam/textbook_content_sub', payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        }).catch((error) => {
          reject(error)
        })
    })
  },
}
